module.exports = __webpack_public_path__ + "static/media/map.ed33d2b9.png";